var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.history,"options":_vm.tableOptions},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{staticClass:"mr-8",on:{"click":function($event){return _vm.moveTo(item)}}},[_vm._v(" code ")])]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }